
<template>
  <v-container>
    <card-loading-transparent v-if="loading"></card-loading-transparent>
    <home-greetings class="mt-2" v-if="!loading"></home-greetings>
     <v-row class="mt-1">
       <v-col cols="12" class="d-flex justify-center" v-if="cannot_create">
         <v-btn @click="$router.push({name: 'CreateOrder'})" color="d-flex align-center red white--text">
          <v-icon left>mdi-note-plus</v-icon>
          Novo pedido
        </v-btn>
         <v-btn v-if="has_roles(['Seller','Director'])" @click="$router.push({name: 'SellerPage'})" color="ml-2 d-flex align-center red white--text">
          <v-icon left>mdi-store</v-icon>
          Página do Vendedor
        </v-btn>
       </v-col>
     </v-row>
    <v-row class="mt-2" v-if="!loading">
      <v-col cols="12" md="6">
        <v-card class="d-flex pb-2 flex-column elevation-6 rounded-tl-xl" height="100%">
          <v-card-title class="red darken-1 white--text justify-center">
            <v-icon class="mr-2 white--text" large>mdi-plus</v-icon>
            CADASTROS E LISTAGENS
          </v-card-title>
          <v-card-text class="pb-0">
            <div 
              class="py-10 text-subtitle-1 d-flex justify-center"
              v-if="paginatedRegisterMap.filter(el => el.roles.includes(current_user_role_name)).length == 0" 
            >Você não tem acesso aos recursos desta seção.</div>
            <!-- <v-text-field class="mt-5" v-model="search.register" label="Pesquise..." prepend-icon="mdi-magnify"></v-text-field> -->
            <v-list class="py-0 pt-0">
              <v-list-item :disabled="item.disabled" two-line v-for="(item,index) in paginatedRegisterMap.filter(el => el.roles.includes(current_user_role_name))"
                :key="item.text" :class="[[index % 2 === 0 ? '' : 'grey lighten-4 my-n1']]"
                style="background-color: rgb(240, 240, 240)"
              >
                <v-list-item-icon>
                  <v-icon class="mb-n7">{{item.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{item.text}} 
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{item.subtitle}} 
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="!item.disabled">
                  <div class="d-flex">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-if="item.to_register_path" @click="$router.push({name: item.to_register_path, params: item.params}).catch(()=> {})" v-bind="attrs" v-on="on" icon><v-icon>mdi-plus</v-icon></v-btn>
                      </template>
                      <span>Adicionar {{ item.text }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="$router.push({name: item.path_name, params: item.params}).catch(()=> {})" v-bind="attrs" v-on="on" icon><v-icon>mdi-format-list-bulleted</v-icon></v-btn>
                      </template>
                      <span>Listar {{ item.text }}</span>
                    </v-tooltip>
                  </div>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="" cols="12" md="6">
        <v-card class="d-flex pb-2 flex-column elevation-6 rounded-tr-xl" height="100%">
          <v-card-title class="red darken-1 white--text justify-center">
            <v-icon class="mr-2 white--text" large>mdi-cash-multiple</v-icon>
            FINANCEIRO
          </v-card-title>
          <v-card-text class="pb-0">
            <div 
              class="py-10 text-subtitle-1 d-flex justify-center"
              v-if="paginatedFinancialMap.filter(el => el.roles.includes(current_user_role_name)).length == 0" 
            >Você não tem acesso aos recursos desta seção.</div>
            <!-- <v-text-field class="mt-5" v-model="search.financial" label="Pesquise..." prepend-icon="mdi-magnify"></v-text-field> -->
            <v-list class="py-0">
              <v-list-item :disabled="item.disabled" v-for="(item, index) in paginatedFinancialMap.filter(el => el.roles.includes(current_user_role_name))" 
                :key="item.text" :class="[[index % 2 === 0 ? '' : 'grey lighten-4 my-n1']]"
                style="background-color: rgb(240, 240, 240)"
              >
                <v-list-item-icon>
                  <v-icon>{{item.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{item.text}} 
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="!item.disabled">
                  <div class="d-flex">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="$router.push({name: item.path_name}).catch(()=> {})" v-bind="attrs" v-on="on" icon><v-icon>mdi-format-list-bulleted</v-icon></v-btn>
                      </template>
                      <span>Listar {{ item.text }}</span>
                    </v-tooltip>
                  </div>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { drawer } from "@/router/links";

export default {
  name: 'HomeView',
  components: {
    HomeGreetings: () => import('./Greetings'),
  },
  data() {
    return {
      register_map: [],
      financial_map: [],
      search: {
        register:'',
        financial:'',
      },
      current_page:{
        register:1,
        financial:1,
      },
      items_per_page: {
        register: 20,
        financial: 20
      },
      loading: true,
    }
  },
  computed: {
    cannot_create(){
      return !this.isCreditAnalyst()
    },
    filteredRegisterMap() {
      return (this.register_map || []).filter(item =>
        item.text.toLowerCase().includes(this.search.register.toLowerCase())
      ).sort((a, b) => a.text.localeCompare(b.text));
    },
    filteredFinancialMap() {
      return (this.financial_map || []).filter(item =>
        item.text.toLowerCase().includes(this.search.financial.toLowerCase())
      ).sort((a, b) => a.text.localeCompare(b.text));
    },
    paginatedRegisterMap() {
      const startIndex = (this.current_page.register - 1) * this.items_per_page.register;
      const endIndex = startIndex + this.items_per_page.register;
      return this.filteredRegisterMap.slice(startIndex, endIndex);
    },
    paginatedFinancialMap() {
      const startIndex = (this.current_page.financial - 1) * this.items_per_page.financial;
      const endIndex = startIndex + this.items_per_page.financial;
      return this.filteredFinancialMap.slice(startIndex, endIndex);
    },
  },
  mounted () {
    this.loading = true
    const registerGroup = drawer.find(item => item.text === 'CADASTROS' && item.children)
    const financialGroup = drawer.find(item => item.text === 'FINANCEIRO' && item.children)

    this.register_map = registerGroup ? registerGroup.children : []
    this.financial_map = financialGroup ? financialGroup.children : []
    setTimeout(() => {
      this.loading = false
    }, 100);
  },
}
</script>
